import { ShopperAgentIMessageConfigSchema } from "@redotech/redo-model/shopper-agent";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const shopperAgentAdminDemoModeSchema = z.object({
  emailAddresses: z.array(z.string()),
  phoneNumbers: z.array(z.string()),
  skipBufferTriggerKeys: z.array(z.string()),
  skipSentinelTriggerKeys: z.array(z.string()),
});

export const updateAdminShopperAgentSettings = {
  name: "updateAdminShopperAgentSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    enabled: z.boolean(),
    iMessageConfig: ShopperAgentIMessageConfigSchema,
    adminAllowIMessage: z.boolean(),
    adminEnableActionAuthorizationLinks: z.boolean(),
    adminDemoMode: shopperAgentAdminDemoModeSchema,
  }),
  output: z.object({}),
};
